module.exports = __webpack_public_path__ + "static/ojo-0523e541f902bc5650e04c9f5ea01a27.png";